import React from "react";

export default function PDAboutProperty() {
  return (
    <div className="clip-path-bottomRightPostProperty bg-[#F1EAFF] px-4 lg:px-7 py-6 mt-14 lg:mt-11">
      <h3 className="font-openSans text-base lg:text-xl text-brand-textBlack">
        About the property
      </h3>
      <p className="mt-5 font-openSans text-brand-textGrey text-xs lg:text-sm">
        Welcome to this stunning property, a true gem nestled in the heart of a
        vibrant neighborhood. Step into this exquisite property and be
        captivated by its timeless charm and elegance. The attention to detail
        in every corner of this house creates an inviting and comfortable
        atmosphere that will make
      </p>
    </div>
  );
}
